import React, { useState } from "react";
import styles from "./Notes.module.scss";
import { IconButton, Button, Tooltip } from "@material-ui/core";
import { grey, red } from "@material-ui/core/colors";
import {
  mdiTrashCanOutline,
  mdiCheck,
  mdiClose,
  mdiContentCopy,
  mdiPencilOutline,
  mdiFileRemoveOutline,
  mdiPinOutline,
  mdiPinOffOutline,
} from "@mdi/js";
import Icon from "@mdi/react";

const NoteTools = ({
  id,
  referenceId,
  referenceIds,
  model,
  core,
  filename,
  url,
  pinned,
  handleDelete,
  additionalProps,
  handleEdit,
  handleRemoveImage,
  handleCopyImage, // is null if the file is not an image
  handlePin,
  deleteIconColor = red[400],
  otherIconColor = grey[400],
}) => {
  const [confirm, setConfirm] = useState(false);

  const handleConfirmDelete = (open) => {
    setConfirm(open);
  };

  if (confirm) {
    return (
      <div className={styles.listItemText}>
        Delete?
        <IconButton onClick={() => handleConfirmDelete(false)} size="small">
          <Icon path={mdiClose} color={otherIconColor} size={1} />
        </IconButton>
        <IconButton
          onClick={() => handleDelete({ id, referenceId, referenceIds, model, filename, url, core, additionalProps })}
          size="small"
        >
          <Icon path={mdiCheck} color={deleteIconColor} size={1} />
        </IconButton>
      </div>
    );
  }
  return (
    <div className={styles.listItemText}>
      {handlePin && (
        <Tooltip title={pinned ? "Remove Pin" : "Pin"}>
          <IconButton onClick={() => handlePin(id)} size="small">
            <Icon path={pinned ? mdiPinOutline : mdiPinOffOutline} color={otherIconColor} size={1} />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Edit">
        <IconButton onClick={handleEdit} size="small">
          <Icon path={mdiPencilOutline} color={otherIconColor} size={1} />
        </IconButton>
      </Tooltip>
      {handleCopyImage && (
        <Tooltip title="Copy Image">
          <IconButton onClick={() => handleCopyImage(url)} size="small">
            <Icon path={mdiContentCopy} color={otherIconColor} size={1} />
          </IconButton>
        </Tooltip>
      )}
      {filename && (
        <Tooltip title="Remove Upload">
          <IconButton onClick={() => handleRemoveImage(referenceId, model, core, filename, url, id, additionalProps)} size="small">
            <Icon path={mdiFileRemoveOutline} color={deleteIconColor} size={1} />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Delete">
        <IconButton onClick={() => handleConfirmDelete(true)} size="small">
          <Icon path={mdiTrashCanOutline} color={deleteIconColor} size={1} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default NoteTools;
